import * as React from 'react';
import { faLock, faUnlock } from '@fortawesome/free-solid-svg-icons';
import { INarrative } from '../../../../../../models/narrative';
import { Button } from '../../../../../../components/shared/button/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faEdit, faTrashAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { LinkButton } from '../../../../../../components/shared/link-button/link-button';
import { IExternalReference } from '../../../../../../models/external-reference';
import { compareText } from '../../../../../../helpers/array-helpers';
import { getYouTubeThumbnailUrl } from '../../../../../../helpers/path-helpers';
import { Popup } from '../../../../../../components/shared/popup/popup';
import { ExternalReferenceEditor } from './external-reference-editor';
import { IEpisode } from '../../../../../../models/episode';
import { externalReferenceDelete } from '../../../../../../api/actions/external-reference/external-reference-delete';
import { toast } from 'react-toastify';
import { disableExternalReference } from '../../../../../../api/actions/external-reference/external-reference-disable';
import { enableExternalReference } from '../../../../../../api/actions/external-reference/external-reference-enable';
import styles from './external-reference-editor.module.scss';


interface IProps {
    narrative?: INarrative,
    episode?: IEpisode,
    reloadData(): Promise<void>,
}

function getThumbnailUrl(e: IExternalReference) {
    if(e.externalThumbnailUrl) return getYouTubeThumbnailUrl(e.externalThumbnailUrl);
    else if (e.infoPageUid) return getYouTubeThumbnailUrl(e.infoPageUid);
    
    return '';
}

export function ExternalReferencesManagement(props: IProps) {

    const [externalReferenceUid, setExternalReferenceUid] = React.useState<string>();
    const [externalReferenceEditorVisible, setExternalReferenceEditorVisible] = React.useState(false);
    const [externalReferenceForDelete, setExternalReferenceForDelete] = React.useState<IExternalReference>();

    const relatedObject = (props.narrative || props.episode);

    return (<>
        <div className="list-title">
            <div>External References: <strong>{ relatedObject?.externalReferences?.length || 0}</strong></div>
            <div>
                <Button className="orange" onClick={() => { setExternalReferenceUid(undefined); setExternalReferenceEditorVisible(true); }}>
                    <FontAwesomeIcon icon={faPlus} /> <span>Add External Reference</span>
                </Button>
            </div>
        </div>
        { !!relatedObject?.externalReferences?.length && (
            <table cellPadding="0" cellSpacing="0" className={`list ${styles.list}`}>
                <thead>
                    <tr>
                        <th>External Service Name</th>
                        <th>Thumbnail</th>
                        <th>Service UID</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        relatedObject?.externalReferences
                        .sort((e1, e2) => compareText(e1, e2, (e) => e.serviceName))
                        .map((e: IExternalReference) => (
                            <tr key={e.uid}>
                                <td>
                                    <div className={styles.markContainer}>
                                    <div className={`${styles.mark} ${e.enabled ? '' : styles.disabled}`}>&nbsp;</div>
                                        <div className={styles.title}>
                                            {e.serviceName}
                                        </div>
                                    </div>
                                </td>
                                <td><img src={ getThumbnailUrl(e)} alt={'thumbnail'} height={100} /></td>
                                <td>{e.externalServiceUid}</td>
                                <td className="center">{e.status}</td>
                                <td>
                                    <LinkButton onClick={() => { setExternalReferenceUid(e.uid); setExternalReferenceEditorVisible(true); }}>
                                        <FontAwesomeIcon icon={faEdit} /> Edit
                                    </LinkButton><br />
                                    <LinkButton
                                        className="red"
                                        onClick={() => { setExternalReferenceForDelete(e); }}
                                    >
                                        <FontAwesomeIcon icon={faTrashAlt} /> Delete
                                    </LinkButton><br />
                                <LinkButton
                                    className={e.enabled ? 'black' : 'green'}
                                    onClick={async () => {
                                        if (e.enabled) {
                                            await disableExternalReference(e.uid);
                                        } else {
                                            await enableExternalReference(e.uid);
                                        }
                                        props.reloadData();
                                    }}
                                >
                                    <FontAwesomeIcon icon={e.enabled ? faLock : faUnlock} /> {e.enabled ? 'Disable' : 'Enable'}
                                </LinkButton>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        )}



        { externalReferenceEditorVisible && (
            <Popup
                modal={true}
                title={externalReferenceUid ? 'Edit External Reference' : 'Add External Reference'}
                onClose={() => {
                    props.reloadData();
                    setExternalReferenceEditorVisible(false);
                }}
            >
                <ExternalReferenceEditor
                    uid={externalReferenceUid}
                    narrativeUid={props.narrative?.uid}
                    episodeUid={props.episode?.uid}
                    onClose={() => { props.reloadData(); setExternalReferenceEditorVisible(false); }}
                    reload={props.reloadData}
                />
            </Popup>
        )}

        { externalReferenceForDelete && (
            <Popup
                modal={true}
                className="red"
                title="Delete External Reference"
                onClose={() => {
                    props.reloadData();
                    setExternalReferenceForDelete(undefined);
                }}
                buttons={[
                    {
                        title: <><FontAwesomeIcon icon={faArrowLeft} /> <span>Cancel</span></>,
                        className: 'gray',
                        onClick: () => setExternalReferenceForDelete(undefined),
                    },
                    {
                        title: <><span>Delete</span> <FontAwesomeIcon icon={faTrashAlt} /></>,
                        className: 'red',
                        onClick: async () => {
                            const result = await externalReferenceDelete(externalReferenceForDelete.uid);
                            if(result.success) {
                                props.reloadData();
                                toast.success('Item has been successfully delete');
                                setExternalReferenceForDelete(undefined);
                            }
                        },
                    },
                ]}
            >
                Are you sure want to delete External Reference with name: <strong>{externalReferenceForDelete.serviceName}</strong>?<br />
            </Popup>
        )}
    </>)
}
